import { ExceptionsClient } from "../client/ExceptionsClient";


export function asyncSetter({featureName}, setter) {
    ExceptionsClient.getFeatureStatus({
        featureName : featureName 
    }).then(({valid, data}) => {
        setter(valid && data.status);
    });
}




// WEBPACK FOOTER //
// ./src/commons/api/GetFeatureStatus.js